import { configureStore } from "@reduxjs/toolkit";
import activeUsersReducer from "../features/activeusers/store/activeUsersSlice";

export const store = configureStore({
  reducer: {
    activeUsers: activeUsersReducer,
  },
});
